import { Request } from "../services/Requests";
const RequestBuilder = new Request.Builder("searchdiscover", "price-config", true);
import { PriceConfig } from "../types/articlesearch/Price";

export function getPriceConfig(country: string): Promise<PriceConfig> {
    const template = "/config";
    return RequestBuilder.path(template, {}).query({ country }).get();
}
